export function openInNewTab(href: string) {
  window.open(href, '_blank', 'noopener');
}

export function isInteractiveEventTarget(target: EventTarget) {
  const element = target as Element;
  return (
    typeof element.closest === 'function' &&
    element.closest(
      'a, button, input, select, textarea, label, [role="button"], [role="link"], [role="checkbox"], [role="radio"]',
    ) !== null
  );
}
